import styled from 'styled-components';

const Codespan = styled.code`
    padding: 3px 5px;
    background-color: #ececec;
    font-size: 14px;
`;

export default Codespan;


// WEBPACK FOOTER //
// ./src/components/markdown/Codespan.js